import { render } from "./select.vue?vue&type=template&id=4c416976&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import "./style.less?vue&type=style&index=0&id=4c416976&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c416976"]])

export default __exports__